import { create } from 'zustand'
import { useShallow } from 'zustand/shallow';

export const useEarningsStore = create((set) => ({
  gameSessionResult: null, // { status: Won | Lost }
  showAcceptModal: false,
  maxLevel: null,
  lastPlayedLevel: null,
  lastSessionResult: null,
  earnings: [],

  showBattleNowModal: false,
  battleNowModalScheduled: false,
  battleNowNextLevel: -1,

  addToEarnings: (...newEarnings) => set(state => ({
    earnings: [...state.earnings, ...newEarnings.flat()]
  })),
  popEarning: () => set(state => {
    const [removed, ...rest] = state.earnings;
    return {
      earnings: rest,
    };
  }),
  setMaxLevel: (level) => set(() => ({
    maxLevel: level
  })),
  setGameResult: ({ level, status }) => set(() => ({
    gameSessionResult: {
      status
    },
    showAcceptModal: true,
    lastPlayedLevel: level,
    lastSessionResult: status
  })),
  closeAcceptModal: () => set(() => ({
    showAcceptModal: false,
    gameSessionResult: null
  })),
  displayBattleNowModal: () => set(() => ({
    showBattleNowModal: true,
    battleNowModalScheduled: false,
  })),
  hideBattleNowModal: () => set(() => ({
    showBattleNowModal: null, 
    battleNowModalScheduled: false
  })),
  scheduleBattleNowModal: (level) => set(() => ({
    battleNowModalScheduled: true,
    battleNowNextLevel: level
  })),
  cancelBattleNowModal: () => set(() => ({
    battleNowModalScheduled: false
  })),
}))

const selectGameSessionResult = (state) => {
  if (state.earnings?.length || state.showAcceptModal) {
    return ({
      status: state.status,
      level: state.level
    })
  } else {
    return null;
  }
};

export const useGameSessionResult = () => {
  return useEarningsStore(useShallow(selectGameSessionResult));
}

const debugStore = false;
if (debugStore) {
  useEarningsStore.subscribe((prev, next) => {
    diffPrimitives(next, prev)
  })
}

function diffPrimitives(obj1, obj2) {
  const result = {};
  const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

  for (const key of keys) {
    const val1 = obj1[key];
    const val2 = obj2[key];

    const isPrimitive = val => typeof val !== 'function';

    if (isPrimitive(val1) && isPrimitive(val2)) {
      if (val1 !== val2) {
        result[key] = { from: val1, to: val2 };
        console.log(`[STORE] ${key}: `, val1, ' -> ', val2);
      }
    } else if (isPrimitive(val1) && !(key in obj2)) {
      result[key] = { from: val1, to: undefined };
      console.log(`[STORE] ${key}: `, val1, ' -> ', 'undefined');
    } else if (isPrimitive(val2) && !(key in obj1)) {
      result[key] = { from: undefined, to: val2 };
      console.log(`[STORE] ${key}: `, 'undefined', ' -> ', val2);
    }
  }

  return result;
}
